import LegalLayout from "@/components/site/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" updated="June 2026">
      <p>By using The VIN Verifier website and services, you agree to the following terms.</p>

      <h2>Our Services</h2>
      <p>The VIN Verifier provides mobile VIN verification services performed by a California state-licensed vehicle verifier. We complete DMV REG 31 verifications for eligible vehicles, including out-of-state, dealer, fleet, and specialty vehicles. We do not perform verifications for salvage or rebuilt-title vehicles.</p>

      <h2>Appointments & Availability</h2>
      <p>Submitting a booking request does not guarantee an appointment time until we confirm it with you directly. Mobile service availability and pricing may vary based on your location and vehicle type.</p>

      <h2>Pricing & Payment</h2>
      <p>Pricing is provided by quote and may vary based on vehicle type, location, travel distance and appointment details. We confirm the quoted service price and any applicable travel fee before the appointment. Payment is due upon completion of the verification. We accept cash, Zelle, and major credit cards (a processing fee applies to card payments). Dealer and fleet accounts may be invoiced.</p>

      <h2>Customer Responsibilities</h2>
      <p>You are responsible for providing accurate information, ensuring the vehicle and required documents (title/registration and photo ID) are available at the time of the appointment, and providing safe access to the vehicle.</p>

      <h2>Limitation of Liability</h2>
      <p>Our verification confirms the vehicle identification number as observed at the time of service. We are not responsible for DMV processing decisions, delays, or requirements beyond our control.</p>
    </LegalLayout>
  );
}
